module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 日期：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(30)
      }
    }
  }, [_vm._v("最近30天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 平台来源：  \n\t\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源"
    },
    on: {
      "change": _vm.changePlatform
    },
    model: {
      value: (_vm.pdata.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "platform_id", $$v)
      },
      expression: "pdata.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-option', {
      key: v.platform_id,
      attrs: {
        "label": v.platform_name,
        "value": v.platform_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 小游戏名称：  \n\t\t\t\t"), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择小游戏名称"
    },
    model: {
      value: (_vm.pdata.issued_app_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_id", $$v)
      },
      expression: "pdata.issued_app_id"
    }
  }, _vm._l((_vm.applist), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 操作：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.importData(1)
      }
    }
  }, [_vm._v("投放数据导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.importData(2)
      }
    }
  }, [_vm._v("发行数据导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 模板下载：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTemp(1)
      }
    }
  }, [_vm._v("投放数据导入模板下载")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTemp(2)
      }
    }
  }, [_vm._v("发行数据导入模板下载")])], 1)]), _vm._v(" "), (_vm.list.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "issued_app_id"
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "issued_app_name",
      "label": "",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false,
            "row-key": "channel_id"
          },
          on: {
            "expand-change": _vm.expandsChannel
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "channel_name",
            "label": "",
            "align": "center",
            "width": "48px"
          }
        }, [_vm._v(" ")]), _vm._v(" "), (_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
          attrs: {
            "type": "expand",
            "prop": "issued_app_name",
            "label": "",
            "align": "center",
            "width": "48px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ss) {
              return [_c('el-table', {
                attrs: {
                  "data": ss.row.exData,
                  "show-header": false,
                  "row-key": "d_date"
                }
              }, [_c('el-table-column', {
                attrs: {
                  "prop": "issued_app_name",
                  "label": "",
                  "align": "center",
                  "width": "48px"
                }
              }, [_vm._v(" ")]), _vm._v(" "), _c('el-table-column', {
                attrs: {
                  "prop": "issued_app_name",
                  "label": "",
                  "align": "center",
                  "width": "48px"
                }
              }, [_vm._v(" ")]), _vm._v(" "), _c('el-table-column', {
                attrs: {
                  "prop": "d_date",
                  "label": "日期",
                  "align": "center",
                  "width": "150px"
                }
              }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
                return _c('el-table-column', {
                  attrs: {
                    "prop": item.key,
                    "label": item.name,
                    "align": "center"
                  },
                  scopedSlots: _vm._u([{
                    key: "default",
                    fn: function(scope) {
                      return [(item.key == 'origin_income') ? _c('span', [_vm._v("--")]) : (["visit_uv_new_per", "visit_uv_new_jump", "visit_uv_jump", "visit_uv_new_back_0", "visit_uv_back_0", "total_back_0"].indexOf(item.key) > -1) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row[item.key] || 0) + "%\n\t\t\t\t\t\t\t\t\t\t\t")]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
                    }
                  }], null, true)
                })
              })], 2)]
            }
          }], null, true)
        }) : _c('el-table-column', {
          attrs: {
            "prop": "channel_name",
            "label": "",
            "align": "center",
            "width": "48px"
          }
        }, [_vm._v(" ")]), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "channel_name",
            "label": "渠道名称",
            "align": "center",
            "width": "150px"
          }
        }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
          return _c('el-table-column', {
            attrs: {
              "prop": item.key,
              "label": item.name,
              "align": "center"
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function(scope) {
                return [(item.key == 'origin_income') ? _c('span', [_vm._v("--")]) : (["visit_uv_new_per", "visit_uv_new_jump", "visit_uv_jump", "visit_uv_new_back_0", "visit_uv_back_0", "total_back_0"].indexOf(item.key) > -1) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row[item.key] || 0) + "%\n\t\t\t\t\t\t\t\t")]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
              }
            }], null, true)
          })
        })], 2)]
      }
    }], null, false, 1342485642)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "",
      "align": "center",
      "width": "48px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(item.name))])]
        }
      }, {
        key: "default",
        fn: function(scope) {
          return [(["visit_uv_new_per", "visit_uv_new_jump", "visit_uv_jump", "visit_uv_new_back_0", "visit_uv_back_0", "total_back_0"].indexOf(item.key) > -1) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row[item.key] || 0) + "%\n\t\t\t\t\t")]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
        }
      }], null, true)
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--enable-row-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "totalBox"
  }, [_c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("合计")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("花费")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("活跃")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("活跃单价")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v("新增单价")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "totalBox"
  }, [_c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v(_vm._s(_vm.total.gdt_cost))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v(_vm._s(_vm.total.visit_uv_new))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v(_vm._s(_vm.total.visit_uv))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v(_vm._s(_vm.total.visit_uv_price))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 4
    }
  }, [_vm._v(_vm._s(_vm.total.visit_uv_new_price))])], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("设置显示字段")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("可选字段")]), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.batchDialog,
      "width": "650px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips == 0 ? '导入预览' : '以下数据导入失败'))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0 && _vm.importType == 1) ? _c('el-row', {
      key: index,
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        key: idx,
        attrs: {
          "span": 4
        }
      }, [_vm._v("\n\t\t\t\t\t" + _vm._s(citem) + "\n\t\t\t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0 && _vm.importType == 2) ? _c('el-row', {
      key: index,
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        key: idx,
        attrs: {
          "span": 6
        }
      }, [_vm._v("\n\t\t\t\t\t" + _vm._s(citem) + "\n\t\t\t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.batchTips == '0') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v("确认")]) : _vm._e(), _vm._v(" "), (_vm.batchTips == '1') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v("知道了")]) : _vm._e()], 1) : _vm._e()], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-table__body-wrapper is-scrolling-none"
  }, [_c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v("暂无数据")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-380ef260"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/issue/gdtDataList.vue
// module id = 1130
// module chunks = 2